import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors duration-200"
            aria-label="韩漫在线观看 - 首页"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500" style={{ width: '24px', height: '24px' }}></i>
            </div>
            <span className="font-heading text-xl whitespace-nowrap font-bold">
              韩漫在线观看
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
              }`}
            >
              首页
            </Link>
            {categories.filter((c) => c.slug !== 'all').slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileOpen}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ width: '24px', height: '24px' }}></i>
          </button>
        </div>
      </nav>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50 border-t border-background-200/70 px-4 py-3 space-y-1">
          <Link
            to="/"
            className={`block px-4 py-3 rounded-lg text-sm transition-colors cursor-pointer ${
              location.pathname === '/'
                ? 'text-primary-500 bg-primary-50 font-medium'
                : 'text-foreground-700 hover:bg-background-100'
            }`}
          >
            首页
          </Link>
          {categories.filter((c) => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`block px-4 py-3 rounded-lg text-sm transition-colors cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`block px-4 py-3 rounded-lg text-sm transition-colors cursor-pointer ${
              location.pathname === '/about'
                ? 'text-primary-500 bg-primary-50 font-medium'
                : 'text-foreground-700 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>
      </div>
    </header>
  );
}